import { makeObservable } from 'mobx';

import ReportService from 'src/services/report';
import AntdTablePager from 'src/models/AntdTablePager';
import errorStore from 'src/stores/errorStore';

export default class ReportViewModel {
  pager;

  params = {
    region: undefined,
    keyword: undefined
  };

  constructor() {
    makeObservable(this);

    this.pager = new AntdTablePager(this.query, 20);
  }

  didMount = async () => {
    await this.pager.next(true);
  };

  query = async (limit, anchor) => {
    try {
      const { list, anchor: nextAnchor } = await ReportService.getListBackstage({ ...this.params, limit, anchor });
      return { list, anchor: nextAnchor };

    } catch (err) {
      errorStore.show('發生錯誤，無法取得資訊');
      return { list: [], anchor: null };
    }
  };

  onRegionChange = (value) => {
    this.params.region = value;
    this.pager.next(true);
  };

  onKeywordSearch = (value) => {
    this.params.keyword = value;
    this.pager.next(true);
  };
}
